import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RestudyEconomicManagerDecision, RestudyEconomicDecision, FormMode, Languages, RestudyMeasFirstReviewerDecision } from 'src/app/shared/models/enums.model';
import { ReleaseRestudyRequestDTO, ReleaseRestudyAdminDTO } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';

@Component({
  selector: 'app-Restudy-Cancel-Rebate',
  templateUrl: './Restudy-CancelRebate.component.html'
})
export class RestudyCancelRebateComponent {
  submitted = false;
  loading = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  restudyRequestObj: ReleaseRestudyRequestDTO = new ReleaseRestudyRequestDTO();
  restudyAdminObj: ReleaseRestudyAdminDTO = new ReleaseRestudyAdminDTO();
  //decision = RestudyEconomicManagerDecision;
  managerdecision = RestudyEconomicDecision;
  decision = RestudyMeasFirstReviewerDecision;
  eunitSignedUsersCount: number;
  isRestudy: boolean = true;
  isRefund: boolean = true;
  isSecondStep: boolean = false;
  //isCancelRebate: boolean = false;
  decisionKeys = Object.keys(this.decision);
  ManagerdecisionKeys = Object.keys(this.managerdecision);
  displayedLang: string;
  ShowApprove: boolean = false;
  ShowModify: boolean = false;
  decisionValue: number;
  MdecisionValue: number = 0;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestId: string = '';
  showProceedToManagers: boolean = false;
  user: User = new User();
  showML: boolean = false;
  showSuccess: boolean = false;
  isSubmitButtonDisplayed: boolean = false;
  private isSubmitEnabled: boolean = false;
  restudyMeasFirstReviewerForm: FormGroup;

  isWFSubmitButtonDisplayed: boolean = false;
  initiateworkflowForm: FormGroup;
  CancelRebateworkflowForm: FormGroup;
  public WorkflowActionForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatus: number;
  @Input() public isShow: boolean = true;
  isLoaded: boolean = false;
  ListOfAdmins: [] = [];
  adminsDropdownSettings = {};
  selectedEmails: [] = [];

  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private longhaulserv: LongHaulService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.ManagerdecisionKeys = this.ManagerdecisionKeys.slice(this.ManagerdecisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.user = this.globalSrv.user;
    this.adminsDropdownSettings = {
      singleSelection: false,
      idField: 'Email',
      textField: 'Username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: true
    };
  }
  ngOnInit() {
     this.loadListOfAdmins();
    this.buildForm(null);
  }
  loadListOfAdmins() {
    this.longhaulserv.GetNextStepUsers('SCAServices_RestudyManager').subscribe(d => {
      this.ListOfAdmins = d.Data;
      this.showML = true;
      this.isWFSubmitButtonDisplayed = true;
      this.globalSrv.IsLoaderEnabled = false;
    });
  }

  buildForm(decision) {
    this.CancelRebateworkflowForm = this.formBuilder.group({
      Message: [null, [Validators.required]]
    });
    this.restudyMeasFirstReviewerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_Approve) {
      this.restudyMeasFirstReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Admins: ['',[Validators.required]]
      });
    }
    else if (decision == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_MoreInformation) {
      this.restudyMeasFirstReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }
  }

  get Validate() {
    return this.CancelRebateworkflowForm.controls;
  }
  get workflowActionForm() {
    return this.CancelRebateworkflowForm.controls;
  }
  get form() {
    return this.restudyMeasFirstReviewerForm.controls;
  }
  listChanged() {

    if (this.Validate.Admins && this.Validate.Admins.value != null) {
      this.selectedEmails = this.Validate.Admins.value.map(function (e) {
        return e.Email;
      });
    } else if (this.workflowActionForm.Admins && this.workflowActionForm.Admins.value != null) {
      this.selectedEmails = this.workflowActionForm.Admins.value.map(function (e) {
        return e.Email;
      });
    }
  }


  changeDecision(value) {
    this.buildForm(value);
    this.restudyMeasFirstReviewerForm.patchValue({
      Decision: value
    });
    this.CancelRebateworkflowForm.patchValue({
      Message: this.restudyRequestObj.MeasCreatorCancelationFromula
    });
    this.decisionValue = value;
    if(this.decisionValue == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_Approve){
      this.getNextStepUsers();
    }
    if(this.isSecondStep)
    {
      this.restudyMeasFirstReviewerForm.get('Admins')?.clearValidators();
      this.restudyMeasFirstReviewerForm.get('Admins')?.updateValueAndValidity();
    }
  }
  getNextStepUsers() {
    this.longhaulserv.GetNextStepUsers('SCAServices_RestudyManager').subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          this.ListOfAdmins = resObj.Data;
        }
      }
    )
  }
  nextUsersListChanged() {
    if (this.form.Admins && this.form.Admins.value != null) {
      this.selectedEmails = this.form.Admins.value.map(function (e) {
        return e.Email;
      });
    }
  }
  getRequest() {
    this.longhaulserv.GetRestudyRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.restudyRequestObj = this.responseObj.Data;
          this.requestStatus = this.restudyRequestObj.BaseRequest.StatusId;
          this.isLoaded = true;
          if(this.restudyRequestObj.MeasReviewerCanceledRbateDecision!=null)
            {
              if(this.restudyRequestObj.MeasReviewerCanceledRbateDecision==1){
                this.isSecondStep= true;
              }
            }
          this.decisionValue = this.restudyRequestObj.EunitRegistersDecision;
          //this.isCancelRebate = true;
          this.CancelRebateworkflowForm.patchValue({
            Message: this.restudyRequestObj.MeasCreatorCancelationFromula
          });
        }
      }
    )
  }



  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.restudyMeasFirstReviewerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.restudyAdminObj.AdminEmail = this.user.UserName;
    this.restudyAdminObj.Id = this.baseRequestId;
    if(this.isSecondStep){
    this.restudyAdminObj.MeasManagerCanceledRbateDecision = this.decisionValue;
    }
    else
    {
      this.restudyAdminObj.MeasReviewerCanceledRbateDecision = this.decisionValue;
    }
    if (this.decisionValue == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_Approve) {
      //this.restudyAdminObj.WFNextUsers = this.selectedEmails;
    } else {
      this.restudyAdminObj.MeasManagerCanceledRbateNote = this.restudyMeasFirstReviewerForm.controls.MoreInformation.value;
    }
    if(this.isSecondStep){
      this.longhaulserv.SubmitRestudyMeasManagerCancellationDecision(this.restudyAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {

            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.restudyMeasFirstReviewerForm.reset();
            this.lockTaskErrorMessage = false;
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
            this.showSuccess = true;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
            this.showSuccess = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
            this.showSuccess = false;

          }
        });
    }
    else{
      if (this.decisionValue == RestudyMeasFirstReviewerDecision.MeasFirstReviewer_Approve) {
        this.restudyAdminObj.WFNextUsers = this.selectedEmails;
        this.restudyAdminObj.MeasReviewerCanceledRbateDecision = this.decisionValue;
      } else {

        this.restudyAdminObj.MeasReviewerCanceledRbateNote = this.restudyMeasFirstReviewerForm.controls.MoreInformation.value;
      }
      this.longhaulserv.SubmitRestudyMeasFirstReviewerCancellationDecision(this.restudyAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {

            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.restudyMeasFirstReviewerForm.reset();
            this.lockTaskErrorMessage = false;
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
            this.showSuccess = true;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
            this.showSuccess = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
            this.showSuccess = false;

          }
        });
    }

  }
}
